import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './_PermissionIndicator.scss';

const PermissionIndicator = ({ pillCount, label, value, pillRenderer }) => {
  return (
    <div className="PermissionIndicator">
      {label && (
        <div className="PermissionIndicator__label" data-testid="PermissionIndicator__label">
          {label}
        </div>
      )}
      <div className="PermissionIndicator__pills">
        {[...new Array(pillCount)].map((_, index) => {
          if (pillRenderer) {
            return pillRenderer({ value, index });
          }

          const pillClasses = classNames('PermissionIndicator__pill', {
            'PermissionIndicator__pill--colored': value.includes(index)
          });
          const pillDataTestId = value.includes(index)
            ? 'PermissionIndicator__pill--colored'
            : 'PermissionIndicator__pill';
          return <div key={index} className={pillClasses} data-testid={pillDataTestId} />;
        })}
      </div>
    </div>
  );
};

PermissionIndicator.defaultProps = {
  pillCount: 3
};

PermissionIndicator.propTypes = {
  /**
   * Number of pills to show
   */
  pillCount: PropTypes.number,
  /**
   * Label to appear above the pills
   */
  label: PropTypes.string,
  /**
   * Array of indices (zero-based) of pills to be "selected" (colored)
   */
  value: PropTypes.array.isRequired,
  /**
   * A callback function to custom render a pill with the shape of `({index, value}) => node`
   */
  pillRenderer: PropTypes.func
};

export default PermissionIndicator;
